<template>
<div class="email-code">
    <input id="emailInput" autocomplete="off" name="emailInput" class="email-input" :class="{mb: mb, changeb: email}" :placeholder="$t($loginLangPrefix('userSign.phEmailTips'))" v-model="email" @keyup.enter="next()" @input="emailInput" @blur="emailBlur" />
    <div class="delete" v-show="email" :class="{mb: mb}" @click="deleteInput()"></div>
</div>
</template>
<script>

import logreg from '../js/logreg';

export default {
    name: 'emailinput',
    props: {
        mb: { type: String, default: '' }
    },
    data() {
        return {
            email: '',
            errorTxt: ''
        };
    },
    components: {
    },
    methods: {
        emailInput() {
            this.emailCheck();
            this.$emit('changeErrorTxt', this.errorTxt);
            this.$emit('changeEmail', this.email);
        },
        emailBlur() {
            this.emailCheck(true);
            this.$emit('changeErrorTxt', this.errorTxt);
        },
        emailCheck(state) {
            if (!this.email) {
                this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginEmailTips'));
            } else if (logreg.validate(this.email, 'email')) {
                this.errorTxt = '';
            } else if (state) { this.errorTxt = this.$t(this.$loginLangPrefix('userSign.webLoginEmailTips')); }
        },
        deleteInput() {
            this.email = '';
            this.emailInput();
        },
        next() {
            this.$emit('btnSure');
        }
    },

    beforeMount() {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.email-code {
    div, input {
        // -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
        outline: none;
        border: 0;
        line-height: 1;
    }
    form {
        display: inline;
    }
    position:relative;
    .email-input {
        display: block;
        width: 100%;
        // border-bottom: 1px solid #9D1DFF;
        border-bottom: 1px solid #E3E3E3;
        font-size:16px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(23,23,23,1);
        // padding-bottom: 8px;
        padding: 0 25px 5px 0;
        box-sizing: border-box;
        -webkit-appearance: none;
        border-radius: 0;
        &.mb {
            // border-bottom: rem(1) solid #9D1DFF;
            border-bottom: 1px solid #E3E3E3;
            padding: 0 rem(25) rem(5) 0;
            margin-top: rem(30);
        }
        &.changeb {
            border-bottom: 1px solid #9D1DFF;
        }
    }
    .delete {
        display: block;
        position: absolute;
        right: 0;
        bottom: 5px;
        width: 23px;
        height: 23px;
        background-image: url('../images/delete.png');
        background-repeat: no-repeat;
        background-size: 23px 23px;
        background-position: right center;
        cursor: pointer;
        &.mb {
            width: rem(23);
            height: rem(23);
            bottom: rem(5);
            background-size: rem(23) rem(23);
        }
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color:rgba(181,181,181,1);
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color:rgba(181,181,181,1);
    }
    :-ms-input-placeholder { /* IE 10+ */
        color:rgba(181,181,181,1);
    }
    :-moz-placeholder { /* Firefox 18- */
        color:rgba(181,181,181,1);
    }
}
</style>
